import type { ReactNode } from "react";
import { ErrorBoundary } from "@sentry/react";
import { t } from "../i18n";

/** Plasa de la rădăcina interfeței. Fără ea, o componentă care aruncă la
 *  randare demontează TOT arborele React: omul rămâne cu o pagină albă și nu
 *  pleacă nimic nicăieri. Cu ea, eroarea pleacă în Sentry cu stiva de
 *  componente (`observare.ts`), iar omul vede ce s-a întâmplat și cum iese.
 *
 *  Textele se iau cu `t`-ul de modul, nu cu hook-ul: plasa stă deasupra
 *  providerelor, care pot fi chiar ele cele căzute. Limba e cea pusă deja de
 *  `LimbaProvider` înainte de cădere. */
export default function InterfataCazuta({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary fallback={({ eventId }) => <Cazuta cod={eventId} />}>
      {children}
    </ErrorBoundary>
  );
}

function Cazuta({ cod }: { cod: string }) {
  return (
    <div className="page" role="alert">
      <div className="card" style={{ maxWidth: 520, display: "flex", flexDirection: "column", gap: 10 }}>
        <b>{t("cadere.titlu")}</b>
        <p className="note">{t("cadere.text")}</p>
        {/* Codul e id-ul evenimentului din Sentry: cu el, cine raportează
            problema ne duce direct la stiva ei. Fără DSN (dev) e gol. */}
        {cod && <p className="note">{t("cadere.cod", { cod: cod.slice(0, 8) })}</p>}
        <div style={{ display: "flex", gap: 8 }}>
          <button type="button" className="btn btnp" onClick={() => window.location.reload()}>
            {t("cadere.reincarca")}
          </button>
          <a className="btn" href="/projects">{t("comun.inapoi_la_proiecte")}</a>
        </div>
      </div>
    </div>
  );
}
